<template>
   <div>
      <h1>Conductores en Línea</h1>
        <b-row>
      <b-col md="6" class="my-1">
        <b-form-group label-cols-sm="3" label="Buscar" class="mb-0">
          <b-input-group>
            <b-form-input v-model="filter" class="form-control" placeholder="Buscar conductores en línea"></b-form-input>
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">Limpiar</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>
    <b-table
      show-empty
      stacked="md"
      :items="getActiveTaxiCheckIn"
      :fields="fields"
      :current-page="currentPage"
      :per-page="perPage"
      :filter="filter"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
      @filtered="onFiltered"
      empty-text="No existen registros por mostrar"
      emptyFilteredText="No existen registros por mostrar"
    >

    <template v-slot:[`driver.phoneNumber`]="row">
      {{ row.item.phoneNumber.replace('+52','') }}
    </template>
    <!--
      <template v-slot:cell(checkInTime)="row">
        {{ new Date(new Date(row.item.checkInTime).setHours(new Date(row.item.checkInTime).getHours() - 6)).toLocaleString() }}
      </template> -->
    </b-table>
    <b-row>
      <b-col md="6" class="my-1">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          class="my-0"
        ></b-pagination>
      </b-col>
    </b-row>
    <div class="text-center" v-if="$apollo.queries.getActiveTaxiCheckIn.loading">
        <b-spinner variant="danger" label="Spinning">Cargando</b-spinner>
    </div>
    </div>
</template>

<script>
import gql from 'graphql-tag'
import headers from '@/config/headers.js'
// import { encrypt } from '@/config/headers'
export default {
  data() {
    return {
      getActiveTaxiCheckIn: [],
      fields: [
        // { key: 'driver.id', label: 'ID' },
        { key: 'driver.firstName', label: 'Nombre(s)', sortable: true, sortDirection: 'desc' },
        { key: 'driver.lastName', label: 'Apellidos' },
        { key: 'driver.email', label: 'Correo electrónico' },
        { key: 'driver.phoneNumber', label: 'Número de teléfono' },
        { key: 'driver.license', label: 'Número de licencia' },
        { key: 'driver.cardId', label: 'Número de tarjetón' },
        { key: 'concesion.vehicle.vehicleType.type', label: 'Tipo de vehículo' },
        { key: 'concesion.vehicle.licensePlate', label: 'Número de placas' },
        { key: 'checkInTime', label: 'Hora CheckIn' },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      id: 0,
    }
  },
  apollo: {
    getActiveTaxiCheckIn: {
      query: gql`
      query getActiveTaxiCheckIn{
      getActiveTaxiCheckIn{
        id
         date
          checkInTime
          driver{
            id
            firstName
            lastName
            phoneNumber
            license
            cardId
            email
          }
          concesion{
              id
              vehicle{
                  id
                  licensePlate
                  vehicleType{
                    id
                    type
                  }
              }
          }
      },
     }`,
      context: headers(),
      error (erro) {
        console.log(erro)
      },
      result ({ data, loading, networkStatus }) {
        if (data.getActiveTaxiCheckIn != null) {
          this.totalRows = data.getActiveTaxiCheckIn.length
        }
      },
    },
  },
  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
  },
}
</script>

<style>

</style>
